import { I18n } from '../wrappers';
import moment from 'moment-timezone';
function formatDate(date) {
    if (!(date instanceof moment)) {
        date = moment(date);
    }
    if (!date.isValid())
        return '';
    return date.format(I18n.c('general.formatDate'));
}
function formatDateTime(date) {
    if (!(date instanceof moment)) {
        date = moment(date);
    }
    if (!date.isValid())
        return '';
    return date.format(I18n.c('general.formatDateTime'));
}
/** formatDateTime to the minute (no seconds). */
function formatDateTimeShort(date) {
    if (!(date instanceof moment)) {
        date = moment(date);
    }
    if (!date.isValid())
        return '';
    return date.format(I18n.c('general.formatDateTimeShort'));
}
function formatDateTimeHuman(date) {
    if (!(date instanceof moment)) {
        date = moment(date);
    }
    if (!date.isValid())
        return '';
    const now = moment();
    const format = date.year() === now.year()
        ? 'D MMM HH:mm'
        : 'D MMM YYYY HH:mm';
    return date.format(format);
}
function getTimezone() {
    return I18n.c('general.timezone');
}
export function dateFormatter() {
    return {
        formatDate,
        formatDateTime,
        formatDateTimeShort,
        formatDateTimeHuman,
        getTimezone,
    };
}
//# sourceMappingURL=dateFormatter.js.map